import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { automaticSplitFilters } from './automatic-split.filters';

// `validateSearch` das três rotas (U07). Leve de propósito: é JS inicial.

/** Sheet aberto na URL (`?sheet=`), para o voltar fechar (U26). */
const sheet = z.string().min(1).max(40).optional().catch(undefined);

/** Lista: página (a partir de 1), tamanho e os filtros do legado. */
export const automaticSplitListSearch = listSearchSchema({ ...automaticSplitFilters.shape, sheet });
export type AutomaticSplitListSearch = z.infer<typeof automaticSplitListSearch>;

/** Plano: página local das parcelas e a parcela com o drawer "Transferências" aberto (`?parcela=`). */
export const automaticSplitPlanSearch = listSearchSchema({ parcela: z.coerce.number().int().min(1).optional().catch(undefined), sheet });
export type AutomaticSplitPlanSearch = z.infer<typeof automaticSplitPlanSearch>;

/** Formulário: o drawer aberto (`escrow`, `configuracoes`, `cancelar`). */
export const automaticSplitFormSearch = z.object({ sheet });
export type AutomaticSplitFormSearch = z.infer<typeof automaticSplitFormSearch>;
